export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover trails around the world !"])},
  "cta": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View all trails"])}
}